import {
  VisitorSessionEvent,
  VisitorSessionListItem,
  VisitorSessionSourceSummary,
} from '../models/visitor-session';

export interface BackendPageContextSnapshot {
  surface?: string | null;
  routePath?: string | null;
  hubId?: string | null;
  activityId?: string | null;
  landingKey?: string | null;
  landingPath?: string | null;
}

export interface BackendSessionEventViewDto {
  id?: string | null;
  eventId?: string | null;
  type?: string | null;
  occurredAt?: string | null;
  pageContext?: BackendPageContextSnapshot | null;
  source?: VisitorSessionSourceSummary | null;
  actionDetails?: Record<string, unknown> | null;
  action?: Record<string, unknown> | null;
}

export interface BackendVisitorSessionDetailResponse {
  session?: VisitorSessionListItem | null;
  events?: BackendSessionEventViewDto[] | null;
}

export function mapBackendEvent(dto: BackendSessionEventViewDto): VisitorSessionEvent {
  const pageContext = dto.pageContext;
  const eventId = String(dto.eventId ?? dto.id ?? '').trim();

  return {
    eventId: eventId || null,
    eventType: dto.type ?? null,
    occurredAt: dto.occurredAt ?? null,
    routePath: pageContext?.routePath ?? null,
    landingPath: pageContext?.landingPath ?? null,
    landingKey: pageContext?.landingKey ?? null,
    page: pageContext?.surface ?? null,
    sourceSummary: dto.source ?? null,
    metadata: dto.actionDetails ?? dto.action ?? null,
  };
}

export function mapVisitorSessionDetailResponse(
  response: BackendVisitorSessionDetailResponse | null | undefined
): { session: VisitorSessionListItem | null; events: VisitorSessionEvent[] } {
  return {
    session: response?.session ?? null,
    events: (response?.events ?? []).map(mapBackendEvent),
  };
}
